import {
  ActivitiesSection,
  Cover,
  Header,
  Main,
  Promos,
  ScoreGraph,
  ServicesCards
} from 'components';
import { useEffect, useState } from 'react';
import { activities, graphs, promos, services } from 'static';
import { ActivitiesData, CoverData, GraphData, PromosData, ServicesData } from 'types';

import { Section } from './styles';

export const HomeMovement: React.FC = () => {
  const [graph, setGraph] = useState<GraphData>({} as GraphData);
  const [movementServices, setMovementServices] = useState<ServicesData[]>([] as ServicesData[]);
  const [movementPromos, setMovementPromos] = useState<PromosData[]>([] as PromosData[]);
  const [coverContent, setCoverContent] = useState<CoverData>({} as CoverData);
  const [activitiesContent, setActivitiesContent] = useState<ActivitiesData[]>(
    [] as ActivitiesData[]
  );

  useEffect(() => {
    setMovementServices(services.filter(({ area, card }) => area === 'movimento' && card.show));
    setMovementPromos(promos.filter(({ area }) => area === 'movimento'));
    setActivitiesContent(activities.filter(({ area }) => area === 'movimento'));
    setCoverContent(
      services.filter(({ slug }) => slug === '/movimento/inicio').shift()?.cover ||
        ({} as CoverData)
    );
  }, []);

  useEffect(() => {
    const currentGraph = graphs.filter(({ area }) => area === 'movimento').shift();
    if (currentGraph) setGraph(currentGraph);
  }, []);

  return (
    <>
      <Header />
      <Main>
        <Cover {...coverContent} />
        <Promos promos={movementPromos} />
        <Section>
          <div className="intro">
            <h2>Pontos</h2>
            <p>Conquista objetivos e ganha pontos!</p>
          </div>
          {graph.area && <ScoreGraph graph={graph} card_size="md" />}
        </Section>
        <ActivitiesSection activities={activitiesContent} />
        <ServicesCards
          services={movementServices}
          title="A pensar em si"
          description="Selecione um serviço e prepare-se para conquistar mais pontos"
        />
      </Main>
    </>
  );
};
